import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Logger, LogService } from 'src/app/nio-common/util';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {
  private readonly _logger!: Logger;

  constructor(private readonly logService: LogService) {
    this._logger = this.logService.createLogger(AuthorizationInterceptor.name);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      withCredentials: true,
    });
    return next.handle(request).pipe(
      catchError(err => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          window.location.href = environment.frontendAppUrl;
        }
        throw err;
      }),
      map((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse && event.status === 401) {
          location.href = environment.frontendAppUrl;
        }
        return event;
      }),
    );
  }
}
